module.exports = __webpack_public_path__ + "img/24.f64fa149.png";